/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getTimecard} from '../api'

 export const useQueryGetTimecard = createReactQueryHook('getTimecard', getTimecard)
